<template>
  <!-- 应用bottomcolor作为背景颜色，添加渐变效果 -->
  <div class="page-container" :style="{
    'color': textColor
  }" :class="{ 'has-bg-image': backgroundImageUrl }">
    <div class="background-layer" :style="{ 'background-image': `url(${backgroundImageUrl})` }"></div>
    <!-- 用户登录/信息区域 - 更现代化的设计 -->
    <div class="user-area">
      <div class="user-info-box" v-if="isLoggedIn">
        <div class="user-avatar-wrapper" @click="showDropdown = !showDropdown">
          <el-avatar :size="45" :src="userInfo.face" class="user-avatar" />
          <div class="user-badge">
            <el-icon>
              <StarFilled />
            </el-icon>
          </div>
        </div>

        <transition name="el-zoom-in-top">
          <div v-if="showDropdown" class="user-dropdown-menu">
            <div class="dropdown-header">
              <el-avatar :size="52" :src="userInfo.face" class="dropdown-avatar" />
              <div class="user-details">
                <h3>{{ userInfo.uname }}</h3>
                <p class="user-id">UID: {{ userInfo.mid }}</p>
                <p class="user-integral">积分: {{ settingData.Integral }}</p>
              </div>
            </div>

            <div class="dropdown-divider"></div>

            <div class="dropdown-item" @click="goToExchangeRecords">
              <el-icon>
                <Clock />
              </el-icon>
              <span>兑换记录</span>
            </div>

            <div class="dropdown-item" @click="logout2">
              <el-icon>
                <SwitchButton />
              </el-icon>
              <span>退出登录</span>
            </div>
          </div>
        </transition>
      </div>

      <div class="login-entry" v-else>
        <el-button type="primary" size="small" @click="goToLogin" :icon="User" class="login-button">
          登录
        </el-button>
      </div>
    </div>

    <!-- 导航栏 - 玻璃拟态设计 -->
    <nav class="navbar">
      <ul class="nav-list">
        <li class="nav-item" v-for="item in navItems" :key="item.path" :class="{ 'active': isActive(item.path) }">
          <router-link :to="item.path"
            :style="{ 'background-color': settingData.Navigationcolor || 'rgba(0, 0, 0, 0.7)' }">
            <el-icon :size="18" class="nav-icon">
              <component :is="item.icon" />
            </el-icon>
            <span>{{ item.name }}</span>
          </router-link>
        </li>
      </ul>
    </nav>

    <!-- 主内容区域 - 卡片玻璃拟态效果 -->
    <div class="link-integral-container" :style="{ '--theme-color': settingData.color || '#ffffff' }">
      <el-card class="main-card glass-effect" shadow="hover" :style="{ 'background-color': cardBackgroundColor }">
        <template #header>
          <div class="header-title">
            <el-icon class="title-icon">
              <Link />
            </el-icon>
            <span>{{ settingData.nickname }}的虚拟空间</span>
          </div>
        </template>

        <!-- 主播信息展示 -->
        <div class="vtuber-info">
          <div class="vtuber-avatar" v-if="settingData.homepageImage">
            <el-image :src="settingData.homepageImage" fit="cover" :preview-src-list="[settingData.homepageImage]" />
          </div>

          <div class="avatar-uploader">
            <el-upload disabled class="avatar-uploader__trigger" :action="uploadUrl" :show-file-list="false"
              :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :http-request="fakeUpload">
              <el-avatar :size="150" v-if="settingData.avatarUrl" :src="ASSET_BASE + settingData.avatarUrl"
                class="avatar" />
              <el-icon v-else>
              </el-icon>
            </el-upload>
          </div>

          <div class="vtuber-desc">
            <h2 class="vtuber-name">{{ settingData.nickname || '' }}</h2>
            <p class="vtuber-slogan">{{ settingData.slogan || '' }}</p>
          </div>
        </div>

        <!-- 链接泡泡按钮区域 -->
        <div class="link-bubble-area">
          <h3 class="section-title">快速链接</h3>
          <div class="bubble-container">
            <!-- 直播房间号泡泡 -->
            <el-button class="bubble-button" :class="{ 'bubble-active': !!urlForm.Live_streaming_room }"
              :style="{ 'background-color': backcolor }"
              @click="openUrlInNewTab(`https://live.bilibili.com/${urlForm.Live_streaming_room}`)"
              v-if="urlForm.Live_streaming_room">
              <el-icon>
                <Platform />
              </el-icon>
              <span>直播间</span>
            </el-button>

            <el-button class="bubble-button" :style="{ 'background-color': backcolor }"
              @click="ElMessage.warning('请先设置直播间号')" v-else>
              <el-icon>
                <Warning />
              </el-icon>
              <span>未设置</span>
            </el-button>

            <!-- 主页URL泡泡 -->
            <el-button class="bubble-button" :class="{ 'bubble-active': !!urlForm.Home_Page }"
              :style="{ 'background-color': backcolor }" @click="openUrlInNewTab(urlForm.Home_Page)"
              v-if="urlForm.Home_Page">
              <el-icon>
                <HomeFilled />
              </el-icon>
              <span>主页</span>
            </el-button>

            <el-button class="bubble-button" :style="{ 'background-color': backcolor }"
              @click="ElMessage.warning('请先设置主页URL')" v-else>
              <el-icon>
                <Warning />
              </el-icon>
              <span>未设置</span>
            </el-button>

            <!-- AFDian链接泡泡 -->
            <el-button class="bubble-button" :class="{ 'bubble-active': !!urlForm.afd }"
              :style="{ 'background-color': backcolor }" @click="openUrlInNewTab(urlForm.afd)" v-if="urlForm.afd">
              <el-icon>
                <Shop />
              </el-icon>
              <span>爱发电</span>
            </el-button>

            <el-button class="bubble-button" :style="{ 'background-color': backcolor }"
              @click="ElMessage.warning('请先设置爱发电链接')" v-else>
              <el-icon>
                <Warning />
              </el-icon>
              <span>未设置</span>
            </el-button>
          </div>
        </div>
      </el-card>
    </div>
  </div>


  <div class="floating-button-container">
    <el-tooltip content="反馈" placement="left">
      <el-button class="floating-button" type="primary" circle :style="{ width: '56px', height: '56px' }"
        @click="handleClick">
        <el-icon size="30">
          <Service />
        </el-icon>
      </el-button>
    </el-tooltip>
  </div>

  <!-- 反馈表单对话框 -->
  <el-dialog v-model="floatingVisible" title="用户反馈" width="500px" custom-class="feedback-dialog"
    :close-on-click-modal="false">
    <el-form :model="feedbackForm" :rules="feedbackRules" ref="feedbackFormRef" label-width="100px">
      <el-form-item label="你的B站UID" prop="userId">
        <el-input v-model="feedbackForm.userId" placeholder="请输入你的用户ID"></el-input>
      </el-form-item>

      <el-form-item label="问题类型" prop="problemType">
        <el-select v-model="feedbackForm.problemType" placeholder="请选择问题类型">
          <el-option label="加群审核" value="加群审核"></el-option>
          <el-option label="禁言申诉" value="禁言申诉"></el-option>
          <el-option label="私信补发" value="私信补发"></el-option>
          <el-option label="音声礼物" value="音声礼物"></el-option>
          <el-option label="物流相关" value="物流相关"></el-option>
          <el-option label="其他" value="其他"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="问题描述" prop="problemDesc">
        <el-input v-model="feedbackForm.problemDesc" type="textarea" :rows="4" placeholder="请详细描述你的问题..."></el-input>
      </el-form-item>

      <el-form-item label="QQ联系方式" prop="contactInfo">
        <el-input v-model="feedbackForm.contactInfo" placeholder="请留下联系方式以便回复"></el-input>
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="floatingVisible = false">取消</el-button>
        <el-button type="primary" @click="submitFeedback">提交反馈</el-button>
      </span>
    </template>
  </el-dialog>

  <!-- 在template部分的最后，floating-button-container之后添加备案号 -->
  <div class="footer-record">
    <div class="record-text" :style="{ 'color': textColor }">
      <a href="https://beian.miit.gov.cn/" target="_blank" :style="{ 'color': textColor }">
        陕ICP备2025066285号-2
      </a>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed, onUnmounted } from 'vue';
import { ElMessage } from 'element-plus';
import {
  Link,
  Platform,
  HomeFilled,
  Shop,
  Warning,
  User,
  StarFilled,
  SwitchButton,
  Collection,
  Present,
  Headset,
  InfoFilled, Service,
  Coin, Clock
} from '@element-plus/icons-vue';
import axios from 'axios';
import { useRoute, useRouter } from 'vue-router';
import { ASSET_BASE } from '../../util/assetBase';

const route = useRoute();
const router = useRouter();

// 判断当前路由是否激活
const isActive = (path) => {
  return route.path === path;
};

// 计算文本颜色基于背景色
const textColor = computed(() => {
  const bgColor = settingData.bottomcolor || '#000000';
  // 简单计算背景亮度决定文字颜色
  const color = bgColor.replace('#', '');
  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 128 ? '#333' : '#fff';
});

// 计算卡片背景颜色
const cardBackgroundColor = computed(() => {
  const bgColor = settingData.backcolor || 'rgba(255, 255, 255, 0.9)';
  if (bgColor.includes('rgba')) {
    // 如果是rgba，增加透明度
    return bgColor.replace(/[\d\.]+\)$/, '0.85)');
  }
  return bgColor;
});

// 导航项配置
const navItems = [
  { path: '/', name: '首页', icon: HomeFilled },
  { path: '/works', name: '作品', icon: Collection },
  { path: '/points', name: '积分兑换', icon: Coin },
  { path: '/captain', name: '舰长礼物', icon: Present },
  { path: '/songlist', name: '歌单', icon: Headset },
  { path: '/about', name: '关于', icon: InfoFilled }
];

// 背景图片URL
const backgroundImageUrl = ref('');

// 表单数据
const urlForm = reactive({
  Live_streaming_room: '',
  Home_Page: '',
  afd: ''
});

// 用户信息
const isLoggedIn = ref(false);
const userInfo = reactive({
  uname: '',
  mid: '',
  face: ''
});
const showDropdown = ref(false);

// 点击空白处关闭下拉菜单
const handleClickOutside = (event) => {
  const userArea = document.querySelector('.user-area');
  if (userArea && !userArea.contains(event.target)) {
    showDropdown.value = false;
  }
};

// 检查登录状态
const checkLoginStatus = () => {
  const savedUserInfo = localStorage.getItem('userInfo');
  if (savedUserInfo) {
    try {
      const parsedInfo = JSON.parse(savedUserInfo);
      if (parsedInfo.mid) {
        Object.assign(userInfo, parsedInfo);
        isLoggedIn.value = true;
      }
    } catch (e) {
      console.error('解析用户信息失败:', e);
      localStorage.removeItem('userInfo');
    }
  }
};

// 登录跳转
const goToLogin = () => {
  router.push('/user/login');
};

// 退出登录
const logout = async () => {
  try {
    localStorage.removeItem('userInfo');
    isLoggedIn.value = false;
    userInfo.uname = '';
    userInfo.mid = '';
    userInfo.face = '';
    showDropdown.value = false;
    settingData.Integral = 0;

    if (route.path.startsWith('/user')) {
      router.push('/');
    }
  } catch (error) {
    console.error('退出登录失败:', error);
  }
};

const goToExchangeRecords = () => {
  showDropdown.value = false;
  router.push('/exchange-records');
};

const logout2 = async () => {
  try {
    localStorage.removeItem('userInfo');
    isLoggedIn.value = false;
    userInfo.uname = '';
    userInfo.mid = '';
    userInfo.face = '';
    showDropdown.value = false;
    settingData.Integral = 0;

    if (route.path.startsWith('/user')) {
      router.push('/');
    }
    ElMessage.success('已退出登录');
  } catch (error) {
    console.error('退出登录失败:', error);
  }
};

// 获取用户积分
const UserIntegral = async (usermid) => {
  try {
    const response = await axios.post('/adminapi/userapi/integral/check', {
      uid: usermid
    });
    settingData.Integral = response.data.results[0]?.integral || 0;
  } catch (error) {
    console.error('查询积分失败:', error);
    settingData.Integral = 0;
  }
}

// 获取用户信息
const fetchUserInfo = async () => {
  try {
    const response = await axios.get('/adminapi/user/Bmsg', {
      withCredentials: true
    });

    if (response.data.code === 0 && response.data.data) {
      const userData = response.data.data;
      userInfo.uname = userData.uname || '';
      userInfo.mid = userData.mid || '';
      userInfo.face = await setBilibiliAvatar(userData.face);
      isLoggedIn.value = true;
      UserIntegral(userInfo.mid);

      localStorage.setItem('userInfo', JSON.stringify({
        uname: userInfo.uname,
        mid: userInfo.mid,
        face: userInfo.face
      }));
    } else {
      console.error("获取用户信息失败:", response.data.message);
      // 有缓存数据时不清除，降级使用缓存
      if (!localStorage.getItem('userInfo')) {
        logout();
      }
    }
  } catch (error) {
    console.error('请求用户信息失败:', error);
    // 有缓存数据时不清除，降级使用缓存
    if (!localStorage.getItem('userInfo')) {
      logout();
    }
  }
};

const setBilibiliAvatar = async (str) => {
  try {
    const response = await axios.post('/adminapi/user/avater', {
      face: str,
    }, {
      responseType: 'arraybuffer',
      withCredentials: true
    });

    const base64 = btoa(
      new Uint8Array(response.data).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        ''
      )
    );

    return `data:image/jpeg;base64,${base64}`;
  } catch (error) {
    console.error('获取头像失败:', error);
    return '/default-avatar.png';
  }
}

// 主播信息数据
const settingData = reactive({
  nickname: '',
  slogan: '',
  homepageImage: '',
  color: '#ffffff',
  backcolor: 'rgba(255, 255, 255, 0.85)',
  Navigationcolor: 'rgba(0, 0, 0, 0.7)',
  bottomcolor: '#000000',
  Integral: 0,
  avatarUrl: ''
});

// 获取链接数据和主播信息
const fetchData = async () => {
  try {
    const [urlResponse, settingResponse] = await Promise.all([
      axios.get('/adminapi/userapi/url/list'),
      axios.get('/adminapi/setting/list'),
    ]);

    const urlData = urlResponse.data.results[0] || {};
    const settingDataRes = settingResponse.data.results[0] || {};

    urlForm.Live_streaming_room = urlData.Live_streaming_room || '';
    urlForm.Home_Page = urlData.Home_Page || '';
    urlForm.afd = urlData.afd || '';

    settingData.nickname = settingDataRes.title || '';
    settingData.slogan = settingDataRes.content || '';
    settingData.homepageImage = settingDataRes.homepageImage || '';
    settingData.color = settingDataRes.color || '#000000';
    settingData.backcolor = settingDataRes.backcolor || 'rgba(255, 255, 255, 0.9)';
    settingData.Navigationcolor = settingDataRes.Navigationcolor || 'rgba(0, 0, 0, 0.7)';
    settingData.bottomcolor = settingDataRes.bottomcolor || '#000000';
    settingData.avatarUrl = settingDataRes.avater || '';

    // 设置背景图片
    console.log(settingDataRes.page)
    // 优化背景图片设置逻辑
    const defaultBackground = 'https://s.panlai.com/zb_users/upload/2025/05/20250506082830174649131053424.jpg';
    backgroundImageUrl.value = settingDataRes.page ? ASSET_BASE + settingDataRes.page : defaultBackground;

  } catch (error) {
    console.error('加载数据错误:', error);
    // 数据加载失败时使用默认背景
    backgroundImageUrl.value = 'https://s.panlai.com/zb_users/upload/2025/05/20250506082830174649131053424.jpg';
  }

};

const openUrlInNewTab = (url) => {
  if (url) {
    window.open(url, '_blank', 'noopener noreferrer');
  } else {
    ElMessage.warning('URL不能为空');
  }
};

// 计算属性：获取backcolor
const backcolor = computed(() => settingData.backcolor || 'rgba(255, 255, 255, 0.8)');

onMounted(() => {
  checkLoginStatus();
  fetchUserInfo();
  fetchData();

  // 添加全局点击事件监听
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});

// 点击事件处理
const floatingVisible = ref(false);
// 反馈表单数据
const feedbackForm = reactive({
  userId: '',
  problemType: '',
  problemDesc: '',
  contactInfo: '',
  time: '',
  Solve: '未解决',
  id: ''
});
const generateId = () => {
  // 方法1: 使用时间戳和随机数生成唯一ID
  const timestamp = Date.now().toString(36)
  const random = Math.random().toString(36).substr(2, 5)
  var nameid = `${timestamp}${random}`
  return nameid

}
const feedbackFormRef = ref(null);
const feedbackRules = reactive({
  userId: [{ required: true, message: '请输入你的B站UID', trigger: 'blur' }],
  problemType: [{ required: true, message: '请选择问题类型', trigger: 'change' }],
  problemDesc: [{ required: true, message: '请描述你的问题', trigger: 'blur' }],
  contactInfo: [{ required: true, message: '请留下联系方式', trigger: 'blur' }]
});
const handleClick = () => {
  console.log('反馈按钮被点击')
  floatingVisible.value = true
}
const submitFeedback = async () => {
  // 表单声明了 :rules 却从不校验，空字段会直接写进 Feedback 表
  if (feedbackFormRef.value) {
    try {
      await feedbackFormRef.value.validate();
    } catch (e) {
      return; // 校验不通过，字段下方已有提示
    }
  }
  feedbackForm.time = formatTime(Date.now())
  feedbackForm.id = generateId()
  try {
    var response = await axios.post('/adminapi/Feedback/add', feedbackForm)
    if (response.data && response.data.code === 200) {
      floatingVisible.value = false
      ElMessage.success('反馈成功');
      resetFeedbackForm()
    } else {
      floatingVisible.value = false
      ElMessage.error((response.data && response.data.message) || '反馈失败');
    }
  } catch (error) {
    console.error('反馈提交失败:', error)
    floatingVisible.value = false
    ElMessage.error('反馈失败，请稍后重试');
  }
}
const formatTime = (time) => {
  const date = new Date(time);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day} ${hour}:${minute}`;
};
const resetFeedbackForm = () => {
  feedbackForm.userId = '';
  feedbackForm.problemType = '';
  feedbackForm.problemDesc = '';
  feedbackForm.contactInfo = '';
  feedbackForm.time = '';
  feedbackForm.Solve = '未解决';
  feedbackForm.id = '';
};
</script>
<style lang="scss" scoped>
/* 基础样式 */
:root {
  --glass-blur: 8px;
  --glass-border: 1px solid rgba(255, 255, 255, 0.18);
  --glass-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.page-container {
  min-height: 100vh;
  padding: 20px;
  position: relative;
  background: none !important;
  /* 移除任何背景设置 */
}

.page-container::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  opacity: 0.1;
  z-index: -1;
  /* 使用CSS变量动态设置背景图片 */
  background-image: var(--bg-image, url('https://s.panlai.com/zb_users/upload/2025/05/20250506082830174649131053424.jpg'));
}

/* 用户区域样式 - 更现代化的设计 */
.user-area {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 100;

  .user-info-box {
    position: relative;

    .user-avatar-wrapper {
      position: relative;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        transform: scale(1.05);

        .user-badge {
          transform: translate(30%, -30%) scale(1.2);
        }
      }

      .user-avatar {
        border: 2px solid rgba(255, 255, 255, 0.8);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        transition: all 0.3s ease;
      }

      .user-badge {
        position: absolute;
        top: 0;
        right: 0;
        background: linear-gradient(135deg, #ff4081, #7b1fa2);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 12px;
        transform: translate(30%, -30%);
        transition: transform 0.3s ease;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        z-index: 1;

        .el-icon {
          width: 12px;
          height: 12px;
        }
      }
    }

    .user-dropdown-menu {
      position: absolute;
      top: 60px;
      right: 0;
      width: 260px;
      background: rgba(255, 255, 255, 0.95);
      border-radius: 12px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
      overflow: hidden;
      z-index: 200;
      backdrop-filter: blur(var(--glass-blur));
      border: var(--glass-border);

      .dropdown-header {
        padding: 20px;
        display: flex;
        background: linear-gradient(135deg, rgba(245, 247, 250, 0.8), rgba(228, 231, 235, 0.8));
        border-bottom: 1px solid rgba(238, 238, 238, 0.5);

        .dropdown-avatar {
          margin-right: 15px;
          border: 3px solid white;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        }

        .user-details {
          flex: 1;

          h3 {
            margin: 0 0 5px;
            color: #333;
            font-weight: 600;
            font-size: 16px;
          }

          .user-id {
            margin: 0;
            color: #666;
            font-size: 12px;
          }

          .user-integral {
            margin: 5px 0 0;
            color: #e6a23c;
            font-size: 14px;
            font-weight: bold;
          }
        }
      }

      .dropdown-divider {
        height: 1px;
        background: rgba(238, 238, 238, 0.5);
        margin: 0 15px;
      }

      .dropdown-item {
        padding: 12px 20px;
        display: flex;
        align-items: center;
        cursor: pointer;
        color: #666;
        font-weight: 500;
        transition: all 0.2s ease;

        &:hover {
          background: rgba(245, 247, 250, 0.8);
          color: #ff4081;

          .el-icon {
            color: #ff4081;
          }
        }

        .el-icon {
          margin-right: 10px;
          font-size: 16px;
          color: #777;
          transition: color 0.2s ease;
        }
      }
    }
  }
}

.login-entry {
  .login-button {
    background: linear-gradient(135deg, #6a11cb, #2575fc);
    border: none;
    border-radius: 20px;
    padding: 8px 20px;
    box-shadow: 0 4px 10px rgba(37, 117, 252, 0.3);
    transition: all 0.3s ease;
    font-weight: 500;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 12px rgba(37, 117, 252, 0.4);

      .el-icon {
        transform: translateX(3px);
      }
    }

    .el-icon {
      transition: transform 0.3s ease;
    }
  }
}

/* 导航栏样式 - 玻璃拟态设计 */
.navbar {
  position: relative;
  z-index: 1;
  margin-bottom: 30px;
  backdrop-filter: blur(var(--glass-blur));

  .nav-list {
    display: flex;
    justify-content: center;
    list-style: none;
    padding: 0;
    margin: 0;
    flex-wrap: wrap;
    gap: 10px;
  }

  .nav-item {
    a {
      color: white;
      text-decoration: none;
      font-size: 15px;
      padding: 10px 18px;
      border-radius: 20px;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      backdrop-filter: blur(var(--glass-blur));
      border: var(--glass-border);

      &:hover {
        opacity: 0.9;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      }

      &.router-link-active {
        box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
        font-weight: bold;
      }

      .nav-icon {
        margin-right: 8px;
      }
    }
  }
}

/* 玻璃拟态效果 */
.glass-effect {
  backdrop-filter: blur(var(--glass-blur));
  border: var(--glass-border) !important;
  box-shadow: var(--glass-shadow) !important;
  background: rgba(255, 255, 255, 0.85) !important;
}

/* 主内容区域 - 增强玻璃拟态效果 */
.link-integral-container {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  perspective: 1000px;
  /* 添加透视效果 */


  .main-card {
    border-radius: 20px !important;
    overflow: hidden;
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    transform-style: preserve-3d;
    position: relative;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3) !important;
    border: 1px solid rgba(255, 255, 255, 0.18) !important;

    &:hover {
      transform: translateY(-8px) scale(1.01);
      box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2) !important;
    }


  }

  /* 卡片标题样式 */
  .header-title {
    display: flex;
    align-items: center;
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--theme-color);
    padding: 18px 24px;
    position: relative;
    overflow: hidden;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 24px;
      right: 24px;
      height: 2px;
      background: linear-gradient(90deg,
          rgba(var(--theme-color-rgb), 0.5) 0%,
          transparent 100%);
    }

    .title-icon {
      margin-right: 12px;
      color: var(--theme-color);
      font-size: 1.8rem;
      transition: transform 0.3s ease;
    }

    &:hover .title-icon {
      transform: rotate(15deg);
    }
  }

  /* 主播信息区域 */
  .vtuber-info {
    display: flex;
    align-items: center;
    padding: 24px;
    gap: 24px;
    flex-wrap: wrap;

    .vtuber-avatar {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      overflow: hidden;
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
      transition: all 0.3s ease;
      border: 4px solid rgba(255, 255, 255, 0.3);

      &:hover {
        transform: scale(1.05);
        box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
      }

      .el-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .vtuber-desc {
      flex: 1;
      min-width: 200px;

      .vtuber-name {
        margin: 0 0 8px;
        font-size: 1.8rem;
        font-weight: 700;
        color: var(--theme-color);
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
      }

      .vtuber-slogan {
        margin: 0;
        font-size: 1rem;
        color: var(--theme-color);
        line-height: 1.6;
        position: relative;
        padding-left: 16px;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          height: 60%;
          width: 4px;
          background: linear-gradient(to bottom, var(--theme-color), #a166ab);
          border-radius: 2px;
        }
      }
    }
  }

  /* 链接泡泡区域 */
  .link-bubble-area {
    padding: 0 24px 24px;

    .section-title {
      margin: 0 0 20px;
      font-size: 1.2rem;
      font-weight: 600;
      color: var(--theme-color);
      position: relative;
      display: inline-block;

      &::after {
        content: '';
        position: absolute;
        bottom: -6px;
        left: 0;
        width: 100%;
        height: 3px;
        background: linear-gradient(90deg,
            var(--theme-color),
            transparent);
        border-radius: 3px;
      }
    }

    .bubble-container {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      justify-content: center;
    }

    .bubble-button {
      width: 120px;
      height: 120px;
      border-radius: 50% !important;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
      position: relative;
      overflow: hidden;
      border: none !important;
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);

      /* 泡泡按钮的发光效果 */
      &::before {
        content: '';
        position: absolute;
        top: -50%;
        left: -50%;
        width: 200%;
        height: 200%;
        background: radial-gradient(circle,
            rgba(255, 255, 255, 0.4) 0%,
            transparent 70%);
        transform: scale(0);
        transition: transform 0.6s ease;
      }

      &:hover {
        transform: translateY(-8px) scale(1.05);
        box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);

        &::before {
          transform: scale(1);
        }

        .el-icon {
          transform: scale(1.2);
        }
      }

      &.bubble-active {
        background: linear-gradient(135deg,
            v-bind(backcolor),
            rgba(255, 255, 255, 0.1)) !important;
        color: var(--theme-color);

        .el-icon {
          color: var(--theme-color);
        }
      }

      .el-icon {
        font-size: 2rem;
        margin-bottom: 8px;
        transition: all 0.3s ease;
        color: var(--theme-color);
      }

      span {
        font-size: 0.9rem;
        font-weight: 500;
      }
    }
  }

  /* 弹出框内容样式 */
  .popover-content {
    padding: 12px;

    .popover-link {
      display: flex;
      align-items: center;
      padding: 10px 16px;
      border-radius: 8px;
      color: var(--theme-color);
      text-decoration: none;
      transition: all 0.3s ease;
      background: rgba(var(--theme-color-rgb), 0.1);

      &:hover {
        background: rgba(var(--theme-color-rgb), 0.2);
        transform: translateX(5px);
      }

      .el-icon {
        margin-right: 8px;
        font-size: 1.2rem;
      }
    }

    .empty-tip {
      display: flex;
      align-items: center;
      padding: 10px 16px;
      color: #f56c6c;
      font-size: 0.9rem;

      .el-icon {
        margin-right: 8px;
      }
    }
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .link-integral-container {
    padding: 10px;

    .vtuber-info {
      flex-direction: column;
      text-align: center;
      padding: 16px;

      .vtuber-desc {
        .vtuber-slogan {
          padding-left: 0;

          &::before {
            display: none;
          }
        }
      }
    }

    .bubble-button {
      width: 100px;
      height: 100px;
    }
  }
}

@media (max-width: 480px) {
  .link-integral-container {
    .header-title {
      font-size: 1.2rem;
      padding: 12px 16px;
    }

    .vtuber-info {
      .vtuber-avatar {
        width: 80px;
        height: 80px;
      }

      .vtuber-name {
        font-size: 1.4rem;
      }
    }

    .bubble-button {
      width: 80px;
      height: 80px;

      .el-icon {
        font-size: 1.5rem;
      }

      span {
        font-size: 0.8rem;
      }
    }
  }
}

.page-container.has-bg-image {
  background-image: url('');
  /* 这里通过JS动态设置 */
}

/* 添加背景层 */
.background-layer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  z-index: -1;
  /* 确保在内容层下方 */
  // filter: brightness(0.7);
  /* 适当降低亮度增加可读性 */

  /* 如果需要覆盖渐变效果 */

}

.floating-button-container {
  display: flex;
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 1000;
}

.floating-button {

  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  background-color: #409EFF;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  width: 56px;
  height: 56px;

  &:hover {
    transform: scale(1.08);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
  }

  &:active {
    transform: scale(0.95);
  }
}
/* 在style部分添加备案号样式 */
.footer-record {
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 10;
  padding: 8px 0;
  backdrop-filter: blur(8px);
  background-color: rgba(0, 0, 0, 0.2);
  
  .record-text {
    font-size: 12px;
    letter-spacing: 0.5px;
    
    a {
      text-decoration: none;
      transition: opacity 0.3s;
      
      &:hover {
        opacity: 0.8;
        text-decoration: underline;
      }
    }
  }
}
</style>